import Intro from './Intro';
import MissionIntro from './MissionIntro';
import MissionGame from './MissionGame';
import MissionOutro from './MissionOutro';

export default [Intro, MissionIntro, MissionGame, MissionOutro];
